export default {
      id: "doneSmall-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#doneSmall-usage",
      toString: function () {
        return this.url;
      }
    }